export const environment = {
    production: true,
    version: "POTBI-QA-2.5.1",
    keycloak: {
        authority: 'https://potbi2-qa.timix.cl',
        redirectUri: 'https://potbi2-qa.timix.cl',
        postLogoutRedirectUri: 'https://potbi2-qa.timix.cl',
        realm: 'potbi',
        clientId: 'potbi-front',
    },
    urlSocket: 'https://potbi2-qa.timix.cl/api/notificacion/stomp',
    urlNotificacion: 'https://potbi2-qa.timix.cl/planificacion',
    urlConfiguracion: 'https://potbi2-qa.timix.cl/api/configuracion',
    urlGestion: 'https://potbi2-qa.timix.cl/api/gestion',
    urlReporte: 'https://potbi2-qa.timix.cl/api/reporte',
    urlIntegracion: 'https://potbi2-qa.timix.cl/api/integracion',
    federation :  {
        'gestion': 'https://potbi2-qa.timix.cl/gestion-web/remoteEntry.json',
        'reporte': 'https://potbi2-qa.timix.cl/reporte-web/remoteEntry.json',
        'pos': 'https://potbi2-qa.timix.cl/pos-web/remoteEntry.json',
    }
};
